export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openSampleForm = () => {
    const element = document.getElementById('sample-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3cd0f8818c16c0f375a19e12733dc849.jpg"
          alt="Fire Protection Systems"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          <strong>Your Work Is Critical.</strong>
          <br />
          Your Marketing Shouldn't Be Invisible.
        </h1>

        <p className="text-xl md:text-2xl text-gray-200 mb-4 max-w-4xl mx-auto leading-relaxed">
          We write daily emails for fire protection companies that build trust, increase service agreements, and keep you top-of-mind without hype or gimmicks.
        </p>

        <p className="text-lg text-red-400 font-semibold mb-12">
          The only daily email service built specifically for fire protection companies
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => scrollToSection('how-it-works')}
            className="bg-red-600 text-white px-8 py-4 rounded-md text-lg font-semibold hover:bg-red-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            See How It Works
          </button>
          <button
            onClick={openSampleForm}
            className="bg-white text-gray-900 px-8 py-4 rounded-md text-lg font-semibold hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Get Sample Emails
          </button>
        </div>

        {/* Industry Icons */}
        <div className="mt-20 flex items-center justify-center gap-12 text-white/80">
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 flex items-center justify-center mb-2">
              <i className="ri-fire-line text-4xl"></i>
            </div>
            <span className="text-sm">Sprinklers</span>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 flex items-center justify-center mb-2">
              <i className="ri-alarm-warning-line text-4xl"></i>
            </div>
            <span className="text-sm">Alarms</span>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 flex items-center justify-center mb-2">
              <i className="ri-shield-check-line text-4xl"></i>
            </div>
            <span className="text-sm">Life Safety</span>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 flex items-center justify-center mb-2">
              <i className="ri-building-line text-4xl"></i>
            </div>
            <span className="text-sm">Commercial</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}